export const getAttributeNames = (isPrimary, name, operators) => {
  const hasBenefits = operators.length > 0;
  const upperCasedName = {
    ...(name.firstName !== undefined && {
      firstName: name.firstName.toUpperCase(),
    }),
    ...(name.lastName !== undefined && {
      lastName: name.lastName.toUpperCase(),
    }),
  };

  if (!hasBenefits) {
    return name;
  } else if (operators.length == 1) {
    return operators[0];
  } else {
    for (let operator of operators) {
      if (
        operator.firstName == upperCasedName.firstName &&
        operator.lastName == upperCasedName.lastName
      ) {
        return name;
      } else if (operator.lastName !== upperCasedName.lastName) {
        return {};
      } else {
        return { lastName: name.lastName };
      }
    }
  }
};
